import React from "react";

const InputGroup = ({ label, children, description }) => (
  <div className="bg-neutral-900/50 p-6 rounded-xl border border-white/5 space-y-3">
    <div className="flex flex-col">
      <label className="text-sm font-bold text-white uppercase tracking-wider">{label}</label>
      {description && <span className="text-xs text-gray-500 mt-1">{description}</span>}
    </div>
    {children}
  </div>
);

export default InputGroup;
